// e.g. 28/05/2026 → 20260528. Changes daily so the shuffle order changes daily.
export function getDateSeed(): number {
  const now = new Date();

  return now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
}

// Fisher-Yates shuffle with Park-Miller LCG: same seed → same order every time.
// https://en.wikipedia.org/wiki/Lehmer_random_number_generator
// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
export function seededShuffle<T>(array: T[], seed: number): T[] {
  const arr = [...array];

  let s = seed % 2147483647 || 1;

  for (let i = arr.length - 1; i > 0; i -= 1) {
    s = (s * 16807) % 2147483647;

    const j = s % (i + 1);

    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr;
}
